import { DELIVERY_CHANNEL_SAME_DEVICE } from './constants';

const hasDeliveryChannelSameDevice = (participant) => (
  participant.deliveryChannel === DELIVERY_CHANNEL_SAME_DEVICE
);

export default hasDeliveryChannelSameDevice;
